/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetUserFoldersResponseItems,
    GetUserFoldersResponseItemsFromJSON,
    GetUserFoldersResponseItemsFromJSONTyped,
    GetUserFoldersResponseItemsToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetUserFoldersResponse
 */
export interface GetUserFoldersResponse {
    /**
     * 
     * @type {Array<GetUserFoldersResponseItems>}
     * @memberof GetUserFoldersResponse
     */
    items: Array<GetUserFoldersResponseItems>;
}

export function GetUserFoldersResponseFromJSON(json: any): GetUserFoldersResponse {
    return GetUserFoldersResponseFromJSONTyped(json, false);
}

export function GetUserFoldersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserFoldersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetUserFoldersResponseItemsFromJSON)),
    };
}

export function GetUserFoldersResponseToJSON(value?: GetUserFoldersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(GetUserFoldersResponseItemsToJSON)),
    };
}


